import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {EmptyRedirectComponent} from './core/components/empty-redirect/empty-redirect.component';
import {ProfileComponent} from './profile/components/profile/profile.component';
import {NgModule} from '@angular/core';
import {
	ROOT_ADMINISTRATION,
	ROOT_ADMINISTRATION_CHANNELING,
	ROOT_ADMINISTRATION_RULES,
	ROOT_ADMINISTRATION_USER_MANAGEMENT,
	ROOT_AUTHORITY,
	ROOT_CLAIMS_ADMIN,
	ROOT_CLAIMS_COMPLAINT,
	ROOT_CLAIMS_DRIVER,
	ROOT_CLAIMS_EXTERNAL,
	ROOT_CLAIMS_OLSA,
	ROOT_CLAIMS_PRACTICE_CAR,
	ROOT_CLAIMS_PRACTICES,
	ROOT_CLAIMS_PUBLIC,
	ROOT_CLAIMS_SUPERVISOR,
	ROOT_CLAIMS_THEFT,
	ROOT_CONTRACT_CLOSING_ALD,
	ROOT_CONTRACT_CLOSING_DK_BO,
	ROOT_CONTRACT_CLOSING_DK_C,
	ROOT_CONTRACT_CLOSING_DK_OP,
	ROOT_CONTRACT_CLOSING_SP,
	ROOT_DELIVERY,
	ROOT_DIGITAL_SIGN,
	ROOT_FLOTTA_POOL,
	ROOT_BOOKINGS,
	ROOT_INVOICING,
	ROOT_LOGIN,
	ROOT_LOGISTICS,
	ROOT_NOT_FOUND_PAGE,
	ROOT_NOTIFICATION_CENTER,
	ROOT_PROFILE,
	ROOT_REDIRECT,
	ROOT_TYRES,
	ROOT_USER_CHANGE_ALD,
	ROOT_USER_CHANGE_SP,
	ROOT_VERSION,
	ROOT_BOOKINGS_PRELEASE,
	ROOT_BOOKINGS_RELIEF,
	ROOT_MOBILITY,
	ROOT_CARGOS
} from './app-routing-roots';
import {NotFoundPageComponent} from '@shared/components/not-found-page/not-found-page.component';
import {ModulesLoadingGuard} from './modules-loading.guard';
import {
	ADMINISTRATION_CHANNELING_PROFILES,
	ADMINISTRATION_RULES_PROFILES,
	ADMINISTRATION_USER_MANAGEMENT_PROFILES,
	CLAIMS_ADMIN_PROFILES,
	CLAIMS_COMPLAINT_PROFILES,
	CLAIMS_DRIVER_PROFILES,
	CLAIMS_EXTERNAL_SYSTEM_PROFILES,
	CLAIMS_OLSA_PROFILES,
	CLAIMS_PRACTICE_CAR_PROFILES,
	CLAIMS_PRACTICE_PROFILES,
	CLAIMS_PUBLIC_PROFILES,
	CLAIMS_REPAIR_PROFILES,
	CLAIMS_SUPERVISOR_PROFILES,
	CLAIMS_THEFT_PROFILES,
	CONTRACT_CLOSING_ALD_PROFILES,
	CONTRACT_CLOSING_DK_BO_PROFILES,
	CONTRACT_CLOSING_DKC_PROFILES,
	CONTRACT_CLOSING_DKO_PROFILES,
	CONTRACT_CLOSING_SPO_PROFILES,
	CROSS_PERMISSION_DIGITAL_SIGNATURE,
	CROSS_PERMISSION_NOTIFICATION_READER,
	CROSS_PERMISSION_NOTIFICATION_WRITER,
	DELIVERY_PROFILES,
	INVOICING_PROFILES,
	LOGISTICS_PROFILES,
	TYRES_PROFILES,
	USER_CHANGE_ADMIN_PROFILES,
	USER_CHANGE_SP_PROFILES,
	BOOKINGS_PROFILES,
	FLOTTA_POOL_PROFILES,
	CLAIMS_CUSTOM_ADMIN_PROFILES,
	MOBILITY_PROFILES,
	PROFILES_CARGOS
} from './permissions-variables';
import {CrossPermissionGuard} from './cross-permission.guard';
import {LoginComponent} from 'app/core/components/login/login.component';
import {VersionComponent} from '@shared/components/version/version.component';
import {LoginRedirectComponent} from './core/components/login-redirect/login-redirect.component';
import {FindCentersComponent} from '@shared/components/find-centers/find-centers.component';
import {AdministrationPanelComponent} from '@shared/components/administration-pannel/administration-panel.component';


const appRoutes: Routes = [
	{
		path: '',
		pathMatch: 'full',
		component: LoginRedirectComponent
	},
	{
		path: ROOT_DELIVERY,
		canLoad: [ModulesLoadingGuard],
		loadChildren: 'app/delivery/delivery.module#DeliveryModule',
		data: {
			profiles: DELIVERY_PROFILES,
			breadcrumb: 'Delivery'
		}
	},
	{
		path: ROOT_AUTHORITY,
		canLoad: [ModulesLoadingGuard],
		loadChildren: 'app/authority/authority.module#AuthorityModule',
		data: {
			permission: [],
			breadcrumb: 'Authority'
		}
	},
	{
		path: ROOT_CARGOS,
		canLoad: [ModulesLoadingGuard],
		loadChildren: 'app/cargos/cargos.module#CargosModule',
		data: {
			profiles: PROFILES_CARGOS,
			breadcrumb: 'Cargos'
		}
	},
	{
		path: ROOT_NOTIFICATION_CENTER,
		loadChildren: 'app/notification-center/notification-center.module#NotificationCenterModule',
		canLoad: [CrossPermissionGuard],
		data: {
			permission: [CROSS_PERMISSION_NOTIFICATION_WRITER, CROSS_PERMISSION_NOTIFICATION_READER],
			breadcrumb: 'NotificationCenter'
		}
	},
	{
		path: ROOT_DIGITAL_SIGN,
		loadChildren: 'app/digital-sign/digital-sign.module#DigitalSignModule',
		canLoad: [CrossPermissionGuard],
		data: {
			permission: [CROSS_PERMISSION_DIGITAL_SIGNATURE],
		}
	},
	{
		path: ROOT_REDIRECT,
		component: EmptyRedirectComponent
	},
	{
		path: ROOT_PROFILE,
		component: ProfileComponent,
		data: {
			module: ROOT_PROFILE,
			breadcrumb: 'profile',
			endPoint: 'profile'
		}
	},
	{
		path: ROOT_NOT_FOUND_PAGE,
		component: NotFoundPageComponent
	},
	{
		path: ROOT_LOGIN,
		component: LoginComponent
	},
	{
		path: ROOT_CONTRACT_CLOSING_SP,
		canLoad: [ModulesLoadingGuard],
		loadChildren: '@cc-sp-operator/contract-closing-sp-operator.module#ContractClosingSpOperatorModule',
		data: {
			profiles: CONTRACT_CLOSING_SPO_PROFILES,
			breadcrumb: 'ContractClosingSp'
		}
	},
	{
		path: ROOT_CONTRACT_CLOSING_DK_OP,
		canLoad: [ModulesLoadingGuard],
		loadChildren: '@cc-dekra-operator/contract-closing-dekra-operator.module#ContractClosingDekraOperatorModule',
		data: {
			profiles: CONTRACT_CLOSING_DKO_PROFILES,
			breadcrumb: 'ContractClosingDko'
		}
	},
	{
		path: ROOT_CONTRACT_CLOSING_ALD,
		canLoad: [ModulesLoadingGuard],
		loadChildren: '@cc-ald-operator/contract-closing-ald-operator.module#ContractClosingAldOperatorModule',
		data: {
			profiles: CONTRACT_CLOSING_ALD_PROFILES,
			breadcrumb: 'ContractClosingAld'
		}
	},
	{
		path: ROOT_CONTRACT_CLOSING_DK_C,
		canLoad: [ModulesLoadingGuard],
		loadChildren: '@cc-dekra/contract-closing-dekra.module#ContractClosingDekraModule',
		data: {
			profiles: CONTRACT_CLOSING_DKC_PROFILES,
			breadcrumb: 'ContractClosingDk'
		}
	},
	{
		path: ROOT_CONTRACT_CLOSING_DK_BO,
		canLoad: [ModulesLoadingGuard],
		loadChildren: '@cc-dekra-backoffice/contract-closing-dekra-backoffice.module#ContractClosingDekraBackofficeModule',
		data: {
			profiles: CONTRACT_CLOSING_DK_BO_PROFILES,
			breadcrumb: 'ContractClosingDkBo'
		}
	},
	{
		path: ROOT_CLAIMS_ADMIN,
		canLoad: [ModulesLoadingGuard],
		loadChildren: 'app/claims/claims-admin/claims-admin.module#ClaimsAdminModule',
		data: {
			profiles: [...CLAIMS_ADMIN_PROFILES, ...CLAIMS_CUSTOM_ADMIN_PROFILES],
			breadcrumb: 'ClaimsAdmin'
		}
	},
	{
		path: ROOT_CLAIMS_DRIVER,
		canLoad: [ModulesLoadingGuard],
		loadChildren: 'app/claims/claims-driver/claims-driver.module#ClaimsDriverModule',
		data: {
			profiles: CLAIMS_DRIVER_PROFILES
		}
	},
	{
		path: ROOT_CLAIMS_PUBLIC,
		canLoad: [ModulesLoadingGuard],
		loadChildren: 'app/claims/claims-public/claims-public.module#ClaimsPublicModule',
		data: {
			profiles: CLAIMS_PUBLIC_PROFILES
		}
	},
	{
		path: ROOT_CLAIMS_EXTERNAL,
		canLoad: [ModulesLoadingGuard],
		loadChildren: 'app/claims/claims-external/claims-external.module#ClaimsExternalModule',
		data: {
			profiles: CLAIMS_EXTERNAL_SYSTEM_PROFILES,
			breadcrumb: 'ClaimsExternal'
		}
	},
	{
		path: ROOT_CLAIMS_SUPERVISOR,
		canLoad: [ModulesLoadingGuard],
		loadChildren: 'app/claims/claims-supervisor/claims-supervisor.module#ClaimsSupervisorModule',
		data: {
			profiles: CLAIMS_SUPERVISOR_PROFILES,
			breadcrumb: 'ClaimsSupervisor'
		}
	},
	{
		path: ROOT_CLAIMS_OLSA,
		canLoad: [ModulesLoadingGuard],
		loadChildren: 'app/claims/claims-olsa/claims-olsa.module#ClaimsOlsaModule',
		data: {
			profiles: CLAIMS_OLSA_PROFILES,
			breadcrumb: 'ClaimsOlsa'
		}
	},
	// {
	// 	path: ROOT_CLAIMS_REPAIR,
	// 	canLoad: [ModulesLoadingGuard],
	// 	loadChildren: 'app/claims/claims-repair/claims-repair.module#ClaimsRepairModule',
	// 	data: {
	// 		profiles: CLAIMS_REPAIR_PROFILES,
	// 		breadcrumb: 'ClaimsRepair'
	// 	}
	// },
	{
		path: ROOT_CLAIMS_PRACTICE_CAR,
		canLoad: [ModulesLoadingGuard],
		loadChildren: 'app/claims/claims-practice-car/claims-practice-car.module#ClaimsPracticeCarModule',
		data: {
			profiles: CLAIMS_PRACTICE_CAR_PROFILES,
			breadcrumb: 'ClaimsPracticeCar'
		}
	},
	{
		path: ROOT_CLAIMS_THEFT,
		canLoad: [ModulesLoadingGuard],
		loadChildren: 'app/claims/claims-theft/claims-theft.module#ClaimsTheftModule',
		data: {
			profiles: CLAIMS_THEFT_PROFILES,
			breadcrumb: 'ClaimsTheft'
		}
	},
	{
		path: ROOT_CLAIMS_COMPLAINT,
		canLoad: [ModulesLoadingGuard],
		loadChildren: 'app/claims/claims-complaint/claims-complaint.module#ClaimsComplaintModule',
		data: {
			profiles: CLAIMS_COMPLAINT_PROFILES,
			breadcrumb: 'ClaimsComplaint'
		}
	},
	{
		path: ROOT_CLAIMS_PRACTICES,
		canLoad: [ModulesLoadingGuard],
		loadChildren: 'app/claims/claims-practices/claims-practices.module#ClaimsPracticesModule',
		data: {
			profiles: CLAIMS_PRACTICE_PROFILES,
			breadcrumb: 'practice_car',
			endPoint: 'PRACTICE_CAR'
		}
	},
	{
		path: ROOT_USER_CHANGE_ALD,
		loadChildren: 'app/user-change/user-change.module#UserChangeModule',
		canLoad: [ModulesLoadingGuard],
		data: {
			profiles: USER_CHANGE_ADMIN_PROFILES,
			breadcrumb: 'UserChange'
		}
	},
	{
		path: ROOT_INVOICING,
		canLoad: [ModulesLoadingGuard],
		loadChildren: 'app/invoicing/invoicing.module#InvoicingModule',
		data: {
			profiles: INVOICING_PROFILES,
			breadcrumb: 'Invoicing'
		}
	},
	{
		path: ROOT_TYRES,
		canLoad: [ModulesLoadingGuard],
		loadChildren: 'app/tyres/tyres.module#TyresModule',
		data: {
			profiles: TYRES_PROFILES,
			breadcrumb: ''
		}
	},
	/*{
		path: ROOT_TYRES,
		canLoad: [ModulesLoadingGuard],
		loadChildren: 'app/tyres/tyres.module#TyresModule',
		data: {
			profiles: TYRES_SUPER_USER_PROFILES,
			breadcrumb: ''
		}
	},*/
	{
		path: ROOT_LOGISTICS,
		canLoad: [ModulesLoadingGuard],
		loadChildren: 'app/logistics/logistics.module#LogisticsModule',
		data: {
			profiles: LOGISTICS_PROFILES,
			breadcrumb: ''
		}
	},
	{
		path: ROOT_USER_CHANGE_ALD,
		loadChildren: 'app/user-change/user-change.module#UserChangeModule',
		canLoad: [ModulesLoadingGuard],
		data: {
			profiles: USER_CHANGE_ADMIN_PROFILES,
			breadcrumb: 'UserChange'
		}
	},
	{
		path: ROOT_USER_CHANGE_SP,
		loadChildren: 'app/user-change/user-change.module#UserChangeModule',
		canLoad: [ModulesLoadingGuard],
		data: {
			profiles: USER_CHANGE_SP_PROFILES,
			breadcrumb: 'UserChange'
		}
	},
	{
		path: ROOT_VERSION,
		component: VersionComponent,
		canLoad: [ModulesLoadingGuard],
		data: {
			breadcrumb: 'version'
		}
	},
	{
		path: ROOT_ADMINISTRATION_RULES,
		loadChildren: 'app/administration/administration-rules/administration-rules.module#AdministrationRulesModule',
		canLoad: [ModulesLoadingGuard],
		data: {
			profiles: ADMINISTRATION_RULES_PROFILES,
			breadcrumb: 'Administration'
		}
	},
	{
		path: ROOT_ADMINISTRATION,
		component: AdministrationPanelComponent,
		canLoad: [ModulesLoadingGuard],
		data: {
			profiles:[ADMINISTRATION_CHANNELING_PROFILES, ADMINISTRATION_RULES_PROFILES, ADMINISTRATION_USER_MANAGEMENT_PROFILES],
			breadcrumb: 'Administration',
			endPoint: 'administration-panel'
		}
	},
	{
		path: ROOT_ADMINISTRATION_CHANNELING,
		loadChildren: 'app/administration/administration-channeling/administration-channeling.module#AdministrationChannelingModule',
		canLoad: [ModulesLoadingGuard],
		data: {
			profiles: ADMINISTRATION_CHANNELING_PROFILES,
			breadcrumb: 'Administration'
		}
	},
	{
		path: ROOT_FLOTTA_POOL,
		loadChildren: 'app/flotta-pool/flotta-pool.module#FlottaPoolModule',
		canLoad: [ModulesLoadingGuard],
		data: {
			profiles: FLOTTA_POOL_PROFILES,
			breadcrumb: 'Flotta pool'
		}
	},
	{
		path: ROOT_BOOKINGS,
		loadChildren: 'app/bookings/bookings.module#BookingsModule',
		canLoad: [ModulesLoadingGuard],
		data: {
			profiles: BOOKINGS_PROFILES,
			breadcrumb: 'Bookings'
		}
	},{
		path: ROOT_BOOKINGS_RELIEF,
		loadChildren: 'app/bookings/bookings.module#BookingsModule',
		canLoad: [ModulesLoadingGuard],
		data: {
			profiles: BOOKINGS_PROFILES,
			breadcrumb: 'Bookings'
		}
	},
	{
		path: ROOT_BOOKINGS_PRELEASE,
		loadChildren: 'app/bookings/bookings.module#BookingsModule',
		canLoad: [ModulesLoadingGuard],
		data: {
			profiles: BOOKINGS_PROFILES,
			breadcrumb: 'Bookings'
		}
	},
	{
		path: ROOT_ADMINISTRATION_USER_MANAGEMENT,
		loadChildren: 'app/administration/administration-user-management/administration-user-management.module#AdministrationUserManagementModule',
		canLoad: [ModulesLoadingGuard],
		data: {
			//profiles: ADMINISTRATION_USER_MANAGEMENT_PROFILES,
			breadcrumb: 'Administration'
		}
	},
	{
		path: ROOT_MOBILITY,
		canLoad: [ModulesLoadingGuard],
		loadChildren: 'app/mobility/mobility.module#MobilityModule',
		data: {
			// permission: [],
			profiles: MOBILITY_PROFILES,
			breadcrumb: 'Mobility'
		}
	},
	{
		path: '**',
		component: NotFoundPageComponent,
		data: {
			breadcrumb: 'pageNotFound',
			endPoint: 'pageNotFound'
		}
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(
			appRoutes,
			{
				preloadingStrategy: PreloadAllModules, 
				//onSameUrlNavigation : 'reload'
				//enableTracing: true
			}
		)
	],
	exports: [
		RouterModule
	],
	entryComponents : [FindCentersComponent]
})
export class AppRoutingModule {
}
